define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/action",
	"csi/comm",
	"csi/def/Action",
	"csi/heading/Url",
	"csi/html",
	"csi/locale",
	"csi/reflection",
	"csi/service/nodeService",
	"csi/threeD/utility/ThreeDRotationIcon",
	"csi/widget/MessageDialog",
	"csi/widget/TextWithMaterialIcon",
	"csi/xml",
], function(declare, csi, _, csiAction, comm, Action, Url, html, locale, reflection, {resolveNode}, {create3DRotationIcon}, MessageDialog, TextWithMaterialIcon, xml) {

	const icons = {
		Complete: {icon: "cloud_download", title: "Download"},
		InProgress: {icon: "autorenew", title: "DriveStatusIconInProgress"},
		Failed: {icon: "error_outline", title: "DriveStatusIconFailed"},
	};

	return declare(Url, {

		bCanReset: false,

		idStatus: "File.Status",

		/**
		 * @override
		 * Return the Drive-File Herf (link to active download) for the previous Document Revisions otherwise return null (no link needed - Share with me case).
		 */
		_getFileHref: function(ctx, value, fileName) {
			const node = ctx.getNode();
			if (node.DisableDownload) {
				return comm.getFileHref("", false, "");
			} else if (node.IsDriveFile) {
				if (node.State == reflection.REVISION_ABANDONED && node.DriveReviseStatus == "DriveActionState:Complete") {
					return comm.getCentricDriveFileHref(node.$URL, false, fileName);
				} else {
					// no link - Share with me case
					return null;
				}
			} else {
				return this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Redraw row when updated
		 */
		onMonitor: function(amc, newValue) {
			const {ctx} = amc;
			const revision = ctx.getNode();

			resolveNode(revision.Master).then((node) => {
				ctx.cache.add(node);
			    ctx.view.redrawNode(amc.refNode);
			});

			return true;
		},

		/**
		 * Returns whether the node has a valid file
		 * @param {Object} value
		 * @param {Context} ctx
		*/
		hasValidFile: function(value, ctx) {
			// in the case of proofing example setting view, the node doesn't exist
			return xml.isValidURL(value) || ctx.getNode()?.FileChunks;
		},

		/**
		 * @override
		 * Monitor changes to status if In Progress
		 */
		toHtmlStatic: function(ctx, h, refNode, params) {
			const node = ctx.getNode();
			const parent = ctx.getNodeParent();
			const url = this._getValue(ctx, h);
			const {view} = ctx;

			if (node && node.IsDriveFile) {
				const monitor = (id) => {
					if (xml.enumGetText(id) === "InProgress") {
						this.monitor(ctx, h, refNode, id);
					}
				};

				monitor(node.DriveUploadStatus);
				monitor(node.DriveFreezeStatus);
				monitor(node.DriveReviseStatus);

				const value = this.toValue(ctx, h);
				if (node.State !== reflection.REVISION_ABANDONED) {

					const icon = icons[xml.enumGetText(node.DriveUploadStatus)] || {};
					new TextWithMaterialIcon({
						icon: icon.icon,
						iconTitle: locale.resource(icon.title),
						text: value,
						class: "csi-drive-icons",
						onClick: () => {
							if (xml.enumGetText(node.DriveUploadStatus) === "Complete") {
								const action = _.extend(new Action(), {
									m_id: "ShareWithMe",
									classController: "SiteAdmin.CentricDrive.ShareWithMeController",
								});

								action.resolve();

								csiAction.invoke(view, refNode, action);
							}
						}
					}).placeAt(refNode);
					return true;
				}
			}

			if (parent && parent.VariantSource && parent.VariantSource != csi.EMPTY_URL) {
				refNode = html.create("div", {
					class: "csi-flex-row csi-3D-placeholder",
				}, refNode);

				this.inherited(arguments);
				return create3DRotationIcon(view, refNode, url, h, parent);
			} else {
				return this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Dynamically setting up of the BrowseFile Controller
		 */
		_getRenderAction: function(ctx, h) {
			const ad = this.inherited(arguments);
			const node = ctx.getNode();
			if (ad) {
				if (node.IsDriveFile) {
					if (node.DriveUploadStatus !== "DriveActionState:InProgress") {
						ad.action.classController = "csi.heading.DriveFileBrowseController";
					} else {
						return null;
					}
				} else {
					ad.action.classController = "csi.heading.FileBrowseController";
				}
			}
			return ad;
		},

		/**
		 * @override
		 * Create an action that allows the file upload to be aborted
		 * @param {Context} ctx
		 * @return  {Action}
		*/
		_createAbortAction(ctx) {
			const currentRevision = ctx.getNode();
			const dGaaSTemplateRevisionUrl = currentRevision?.DGaaSTemplateRevision;
			const isValidUrl = xml.isValidURL(dGaaSTemplateRevisionUrl);
			const controller = isValidUrl ? "DocumentGenerator/AbortFileGenerationController" : "csi/heading/AbortUploadController";
			const actionId = isValidUrl ? "AbortFileGeneration" : "AbortFileUpload";
			const action = Object.assign(new Action(), {
				classController: controller,
				m_id: actionId,
				confirmIcon: MessageDialog.ICON_ERROR,
				confirmAction: MessageDialog.BUTTON_CONFIRM
			});
			return action;
		},
	});
});
